var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6634 0C15.4016 0 16 0.598018 16 1.33663V14.6634C16 15.4016 15.402 16 14.6634 16H1.33663C0.59843 16 0 15.402 0 14.6634V1.33663C0 0.59843 0.598018 0 1.33663 0H14.6634ZM10.8147 6C9.67914 6 8.90217 6.50188 8.55623 7.08501L8.49967 7.18867V6.1H6.33301V13.7667H8.66634V10.053C8.66634 8.80833 9.12467 8.01667 10.2263 8.01667C10.9861 8.01667 11.3049 8.68853 11.3312 9.88641L11.333 10.053V13.7667H13.6663V9.53233C13.6663 7.246 13.1193 6 10.8147 6ZM4.66634 6H2.33301V13.6667H4.66634V6ZM3.5 2C2.67167 2 2 2.67167 2 3.5C2 4.32833 2.67167 5 3.5 5C4.32833 5 5 4.32833 5 3.5C5 2.67167 4.32833 2 3.5 2Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/Linkedin Icon.9abb936105f3c2af9e2aa8a9dc4b4edd.svg";
export { ForwardRef as ReactComponent };